
import API from '@/api/api_sign'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Box from 'vux/src/components/box/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

export default {
components: {
Group,
Cell,
XButton,
Box,
Datetime,
Loading
},
data () {
return {
extensionDate:'',
text1:'请等待',
show:false
}
},
methods: {
submits(){
let param = {
contractId:this.$route.params.id,
userId:this.$store.state.userInfo.id,
extensionDate:this.extensionDate,
}
if (this.extensionDate === "") {
this.$vux.toast.show({
type:'cancel;',
text:'到期日不能为空'
});
return;
}
this.show = true;
API.signExtension(param).then((res)=>{
if (res.code == '000000') {
this.show = false;
window.location.href =  res.data;
}else{
this.show = false;
this.$vux.toast.show({
type:'cancel;',
text:res.msg
});
}
})
}
}
}



// WEBPACK FOOTER //
// ./src/pages/extension.vue